import React from 'react';
import { Minus, Moon, Plus, Sun } from 'lucide-react';
import { Button } from './Button';
import { formatAED } from '../utils/pack';
import type { Pill } from '../types/platform';
type PillRowProps = {
  pill: Pill;
  reasons?: string[];
  showPrice?: boolean;
  inPack?: boolean;
  onToggle?: () => void;
};
export function PillRow({
  pill,
  reasons,
  showPrice,
  inPack,
  onToggle
}: PillRowProps) {
  const TimingIcon = pill.timing === 'Morning' ? Sun : Moon;
  return <li className={`flex items-center gap-4 rounded-xl border px-4 py-3 transition-colors ${onToggle && !inPack ? 'border-dashed border-white/10 opacity-70' : 'border-white/10 bg-white/[0.02]'}`} data-id="element-91" data-mp="3ldhlu7cn2a1e">
      <span className="h-8 w-3 shrink-0 rounded-full" style={{
      backgroundColor: pill.color
    }} aria-hidden="true" data-id="element-92" data-mp="3vc71rukz5kf0" />
      <div className="min-w-0 flex-1" data-id="element-93" data-mp="1vzl51gxnaptn">
        <p className="font-medium" data-id="element-94" data-mp="1w0mkdxlp1yh6">
          {pill.name} <span className="font-mono text-xs font-normal text-muted-foreground" data-id="element-95" data-mp="20wuu2vh4gzgy">{pill.dose}</span>
        </p>
        <p className="text-sm text-muted-foreground" data-id="element-96" data-mp="2xcbceo93ukmj">{pill.purpose}</p>
        {reasons && reasons.length > 0 && <p className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-97" data-mp="2siysgrfdf204">
            {reasons.map(r => <span key={r} className="rounded-full border border-[#f5b454]/30 px-2 py-0.5 text-[11px] text-[#f5b454]" data-id="element-98" data-mp="2nm88vu4cxo9y">
                {r}
              </span>)}
          </p>}
      </div>
      <span className="hidden items-center gap-1 text-xs text-muted-foreground sm:flex" data-id="element-99" data-mp="3g9m2pjcre3pu">
        <TimingIcon className="size-3.5" data-id="element-100" data-mp="3bccc40dmvm0f" />
        {pill.timing}
      </span>
      {showPrice && <span className="hidden w-20 text-right font-mono text-xs text-muted-foreground sm:block" data-id="element-101" data-mp="36an1umy8jcde">{formatAED(pill.price)}</span>}
      {onToggle && <Button variant={inPack ? 'outline' : 'secondary'} size="sm" onClick={onToggle} aria-label={inPack ? `Remove ${pill.name}` : `Add ${pill.name}`} data-id="element-102" data-mp="1uwt0lc42u9hq">
          {inPack ? <Minus className="size-3.5" data-id="element-103" data-mp="1scmnoexhj8p1" /> : <Plus className="size-3.5" data-id="element-104" data-mp="1sdefdenyoma1" />}
          {inPack ? 'Remove' : 'Add'}
        </Button>}
    </li>;
}